module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray",
    attrs: {
      "id": "register-dateDoctorSchedule"
    }
  }, [_c('time-table', {
    attrs: {
      "areaId": _vm.registInfo.area.areaId,
      "deptId": _vm.registInfo.depart.deptId
    },
    on: {
      "change": _vm.loadDoctorSchedule
    }
  }), _vm._v(" "), _c('scroll', {
    staticStyle: {
      "top": "4.2rem"
    },
    attrs: {
      "id": "has-schedule"
    },
    on: {
      "refresh": _vm.loadDoctorSchedule
    }
  }, [_c('no-record', {
    attrs: {
      "condition": _vm.schedules,
      "tips": "当天没有医生排班，请选择其他日期",
      "id": "register-dateDoctorSchedule-norecord"
    }
  }), _vm._v(" "), _c('ul', {}, _vm._l((_vm.schedules), function(item, index) {
    return _c('li', {
      staticClass: "doctor-section",
      attrs: {
        "id": 'register-dateDoctorSchedule-list-' + index
      },
      on: {
        "click": function($event) {
          return _vm.onSelected(item, index, $event)
        }
      }
    }, [_c('div', {
      staticClass: "doctor-schedule-info"
    }, [_c('div', {
      staticClass: "head doc-header",
      style: ({
        backgroundImage: 'url(' +
          (item.doctAvatar ?
            item.doctAvatar :
            '../../../static/img/ico-doctor.png') +
          ')',
      })
    }, [(item.typeId === '849772') ? _c('span', {
      staticClass: "type-tag tag-putong"
    }, [_vm._v(_vm._s(item.typeName))]) : _vm._e(), _vm._v(" "), (item.typeId === '643075') ? _c('span', {
      staticClass: "type-tag tag-zhuanjia"
    }, [_vm._v(_vm._s(item.typeName))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('p', {
      staticClass: "f-large ellipsis"
    }, [_vm._v("\n              " + _vm._s(item.rankName) + " " + _vm._s(item.doctName) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "flex-row flex-align-center arr-row",
      staticStyle: {
        "border-bottom": "none"
      }
    }, [_c('p', {
      staticClass: "flex-1 f-small ellipsis"
    }, [_c('span', {
      staticClass: "f-minor",
      staticStyle: {
        "margin-right": "0.25rem"
      }
    }, [_vm._v("挂号金额：")]), _c('span', {
      staticClass: "f-strongest"
    }, [_vm._v(_vm._s(_vm._f("formatFee")(item.fee)))])]), _vm._v(" "), _c('p', {
      staticClass: "f-large f-minor"
    }, [_vm._v("\n                剩 "), _c('span', {
      staticClass: "f-strong"
    }, [_vm._v(_vm._s(item.restCount))]), _vm._v(" 号\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row flex-align-end",
      on: {
        "click": function($event) {
          return _vm.openRemain(item, $event)
        }
      }
    }, [_c('p', {
      staticClass: "flex-1 f-small f-minor",
      class: item.showDetailRemain ?
        'doctor-remain-open' :
        'doctor-remain-close',
      attrs: {
        "id": 'doctor-remain-' + index
      }
    }, [_vm._v("\n                " + _vm._s(item.doctDesc ? item.doctDesc : "暂无介绍") + "\n              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.hasMoreRemain),
        expression: "item.hasMoreRemain"
      }],
      class: item.showDetailRemain ? 'arrow-up' : 'arrow-down'
    })])])])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36fd2c8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/register/DateDoctorSchedule.vue
// module id = 811
// module chunks = 0